'use client'

import { cn } from '@/lib/utils'
import { HTMLAttributes } from 'react'

export interface LoadingDotsProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}

const LoadingDots = ({ size = 'md', className, ...props }: LoadingDotsProps) => {
  const sizeClasses = {
    sm: 'h-0.5 w-0.5',
    md: 'h-1 w-1',
    lg: 'h-2 w-2',
    xl: 'h-3 w-3',
  }

  return (
    <div className={cn('flex items-center justify-center py-6', className)} {...props}>
      <div className="flex items-center gap-2">
        <div className={cn('bg-vive-brand-50 animate-pulse rounded-full', sizeClasses[size])}></div>
        <div
          className={cn('bg-vive-brand-50 animate-pulse rounded-full', sizeClasses[size])}
          style={{ animationDelay: '0.2s' }}
        ></div>
        <div
          className={cn('bg-vive-brand-50 animate-pulse rounded-full', sizeClasses[size])}
          style={{ animationDelay: '0.4s' }}
        ></div>
      </div>
    </div>
  )
}

LoadingDots.displayName = 'LoadingDots'

export { LoadingDots }
